import React from 'react';

const BetaFooter: React.FC = () => (
  <footer className="beta-footer" data-testid="beta-footer">
    <span>
      &copy; {new Date().getFullYear()} Alaska Air Group. All rights reserved.
    </span>
  </footer>
);

export default BetaFooter;
